<template>
  <div class="fixed inset-0 pointer-events-none z-[9999]">
    <div class="absolute top-4 right-4 space-y-2 w-[90vw] max-w-sm">
      <transition-group name="toast-fade" tag="div">
        <div
          v-for="t in toasts"
          :key="t.id"
          class="pointer-events-auto flex items-start rounded-lg shadow-lg p-3 animate-slide-in"
          :class="toastClass(t.type)"
        >
          <div class="mr-3 pt-0.5">
            <component :is="iconFor(t.type)" class="w-5 h-5"></component>
          </div>
          <div class="text-sm font-medium flex-1">
            {{ t.message }}
          </div>
          <button
            class="ml-3 text-white/80 hover:text-white"
            @click="close(t.id)"
          >
            ✕
          </button>
        </div>
      </transition-group>
    </div>
  </div>
  
</template>

<script>
import { toasts, toast } from "@/toast";

const IconSuccess = {
  template:
    '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>',
};
const IconError = {
  template:
    '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>',
};
const IconInfo = {
  template:
    '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01"/></svg>',
};
const IconWarning = {
  template:
    '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>',
};

export default {
  name: "ToastContainer",
  data() {
    return { toasts };
  },
  methods: {
    toastClass(type) {
      switch (type) {
        case "success":
          return "bg-green-600 text-white";
        case "error":
          return "bg-red-600 text-white";
        case "warning":
          return "bg-yellow-500 text-black";
        default:
          return "bg-blue-600 text-white";
      }
    },
    iconFor(type) {
      switch (type) {
        case "success":
          return IconSuccess;
        case "error":
          return IconError;
        case "warning":
          return IconWarning;
        default:
          return IconInfo;
      }
    },
    close(id) {
      toast.remove(id);
    },
  },
};
</script>

<style scoped>
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@keyframes slideIn {
  from {
    transform: translateX(24px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.animate-slide-in {
  animation: slideIn 200ms ease-out;
}
</style>


